module PortalLibs.Client.Components.ReactTransitionGroup


open Fable.Core.JsInterop
open Fable.ReactTransitionGroup

importSideEffects "./AnimatedCreate.css"

let AnimatedCreate =
  Feliz.React.memo (
    "AnimatedCreate",
    (fun (props: {| Key: string
                    ContentOpt: Fable.React.ReactElement option |}) ->
      transitionGroup [ TransitionGroupProp.Key props.Key
                        TransitionGroupProp.Component null
                        TransitionGroupProp.Appear true
                        TransitionGroupProp.Exit true ] [
        match props.ContentOpt with
        | None -> ()
        | Some item ->
          cssTransition
            [ CSSTransitionProp.Key "1"
              CSSTransitionProp.Timeout !^500
              CSSTransitionProp.ClassNames !^ "animated-create" ]
            item
      ]),
    (fun (props: {| Key: string
                    ContentOpt: Fable.React.ReactElement option |}) -> $"AnimatedCreate-%s{props.Key}"),
    areEqual = Fable.React.Helpers.equalsButFunctions
  )
